export class Cliente {
    nome: string
    selector: string
}